import { render, staticRenderFns } from "./EditQuestionModal.vue?vue&type=template&id=f63c27a6&scoped=true"
import script from "./EditQuestionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditQuestionModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditQuestionModal.vue?vue&type=style&index=0&id=f63c27a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63c27a6",
  null
  
)

export default component.exports